import React from 'react';
import PropTypes from 'prop-types';
import { Panel } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { faCircle } from '@fortawesome/pro-regular-svg-icons';

import { reorderableList } from 'helpers/react_dnd/reorderable_list';

import PreviewCard from './components/cards/preview';

export const CARD_TYPES = ['leads', 'activity', 'website', 'email', 'custom', 'syndication'];

export class ReportPreview extends React.Component {
  static propTypes = {
    addCard: PropTypes.func,
    addShareableToken: PropTypes.func,
    cards: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        cardType: PropTypes.oneOf(CARD_TYPES).isRequired,
        content: PropTypes.string,
        title: PropTypes.string,
        subtitle: PropTypes.string,
        visibleToClient: PropTypes.bool.isRequired
      })
    ).isRequired,
    fetchingLeads: PropTypes.bool,
    leads: PropTypes.array,
    leadStatuses: PropTypes.array,
    metrics: PropTypes.object.isRequired,
    projectId: PropTypes.number,
    setActiveCard: PropTypes.func,
    updateCard: PropTypes.func,
    updateCardSortOrder: PropTypes.func,
    onUpdateCardVisibility: PropTypes.func
  }

  state = {
    sortedCards: null
  }

  handleReorder = (dragIndex, hoverIndex) => {
    this.setState((prevState) => {
      const sortedCards = [...prevState.sortedCards];
      const dragCard = sortedCards[dragIndex];

      sortedCards.splice(dragIndex, 1);
      sortedCards.splice(hoverIndex, 0, dragCard);

      return { sortedCards };
    });
  }

  handleBeginDrag = () => {
    this.setState({ sortedCards: this.props.cards });
  }

  handleEndDrag = () => {
    this.props.updateCardSortOrder(this.state.sortedCards).then(() => this.setState({ sortedCards: null }));
  }

  renderCard = (card, idx) => {
    const {
      addCard,
      fetchingLeads,
      leads,
      leadStatuses,
      metrics,
      projectId,
      setActiveCard,
      onUpdateCardVisibility
    } = this.props;

    return (
      <PreviewCard
        addCard={addCard}
        card={card}
        fetchingLeads={fetchingLeads}
        index={idx}
        key={card.id}
        leads={leads}
        leadStatuses={leadStatuses}
        metrics={metrics}
        projectId={projectId}
        setActiveCard={setActiveCard}
        onBeginDrag={this.handleBeginDrag}
        onEndDrag={this.handleEndDrag}
        onReorder={this.handleReorder}
        onUpdateCardVisibility={onUpdateCardVisibility}
      />
    );
  }

  handleAddCard = () => {
    if (!this.props.addCard) return;

    this.props.addCard({
      cardType: 'custom',
      content: '',
      title: 'Untitled Card',
      visibleToClient: false
    }).then(this.props.setActiveCard);
  }

  renderNewCardPanel() {
    if (!this.props.addCard) return;

    return (
      <Panel className="report-panel preview-panel new-card-panel">
        <Panel.Body className="clickable" name="addCard" onClick={this.handleAddCard}>
          <div className="fa-stack fa-3x dark-grey">
            <FontAwesomeIcon className="fa-stack-2x" icon={faCircle} />
            <FontAwesomeIcon className="fa-stack-1x" icon={faPlus} />
          </div>

          <div className="text text-center">
            <h3 className="text-muted">Create a custom tile</h3>
            <p className="text-muted">The tile will not be visible to clients until you have created it.</p>
          </div>
        </Panel.Body>
      </Panel>
    );
  }

  render() {
    return (
      <div className="report-tab report-preview">
        {(this.state.sortedCards || this.props.cards).map((card, idx) => this.renderCard(card, idx))}
        {this.renderNewCardPanel()}
      </div>
    );
  }
}

export default reorderableList(ReportPreview);
